import split from 'lodash/split';

export default (search='', word='') => {
  let regex = split(search, '').join('.*').toLowerCase();
  regex = regex.replace('+', '\\+');
  return new RegExp(`.*${regex}.*`).test(word.toLowerCase());
};
